import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconGoTo({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="m10.466 3.11.084.071 4.273 4.381c.064.065.11.141.14.223l.01.032c.006.02.011.039.015.059l.006.04a.59.59 0 0 1 .006.07v.029l-.002.035v-.036l-.003.058-.007.052a.555.555 0 0 1-.015.059l-.012.033a.588.588 0 0 1-.08.153l-.058.07-4.273 4.38a.594.594 0 0 1-.855 0 .631.631 0 0 1-.07-.79l.07-.086 3.237-3.319-11.296.001A.63.63 0 0 1 1 8a.63.63 0 0 1 .636-.625h11.296L9.695 4.057a.631.631 0 0 1-.07-.79l.07-.087a.594.594 0 0 1 .771-.071z"/>
        </svg>
    );
}

export default IconGoTo;
